/**
 * Created by jv on 05/04/2017.
 */
const utils = require("Sources/utils/utils");
const moment = require("moment");

module.exports = class Invoice
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.number = options.number;
    this.ogm = options.ogm;

    this.creationDate = options.date;
    this.dueDate = options["due-date"];

    this.invoiceUrl = options["invoice-url"];
    this.creditnoteUrl = options["creditnote-url"];
  }

  set creationDate(date)
  {
    this._creationDate = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get creationDate()
  {
    return utils.isMomentObject(this._creationDate) ? this._creationDate.format("DD-MM-YYYY") : null;
  }

  set dueDate(date)
  {
    this._dueDate = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get dueDate()
  {
    return utils.isMomentObject(this._dueDate) ? this._dueDate.format("DD-MM-YYYY") : null;
  }
};



// WEBPACK FOOTER //
// ./app/js/models/invoice.js